import { Link } from "react-router-dom";
import CommentsSection from "../components/CommentsSection";
import { useI18n } from "../context/I18nContext";

export default function Discussion() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#F4F4F4] text-black" data-testid="discussion-page">
      <section className="max-w-4xl mx-auto px-5 sm:px-8 pt-10 pb-6">
        <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000] flex items-center gap-2" style={{ fontWeight: 900 }}>
          <span className="w-2 h-2 bg-[#E00000]" />
          {t("disc_tag")}
        </div>
        <h1 className="mt-2 font-serif-display text-black leading-[0.95] text-4xl sm:text-5xl md:text-6xl" style={{ fontWeight: 800 }} data-testid="discussion-heading">
          {t("disc_h1")}
        </h1>
        <p className="mt-4 text-black max-w-3xl text-base sm:text-lg" style={{ fontWeight: 600 }}>
          {t("disc_intro")}
        </p>
        <div className="mt-6 font-mono-civic text-[10px] sm:text-xs uppercase tracking-widest text-black/60 flex flex-wrap gap-3" style={{ fontWeight: 800 }}>
          <Link to="/dashboard" className="underline hover:text-black" data-testid="disc-link-dashboard">{t("disc_link_dashboard")}</Link>
          <span>·</span>
          <Link to="/results" className="underline hover:text-black" data-testid="disc-link-results">{t("disc_link_results")}</Link>
          <span>·</span>
          <Link to="/vote" className="underline hover:text-black" data-testid="disc-link-vote">{t("disc_link_vote")}</Link>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 sm:px-8 pb-20">
        {/* CommentsSection is built to be scrollable & paginated.  Wrapping it in
            a tall min-height container ensures the page never collapses to a
            short scroll, even when there are very few comments. */}
        <div className="min-h-[60vh]">
          <CommentsSection />
        </div>
      </section>
    </div>
  );
}
